export default '<svg t="1566906748864" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7444" width="200" height="200"><path d="M64.1 281.4l284.4 164.2V117.2z" fill="#333333" p-id="7445"></path><path d="M621.5 906.8H149.4v-85.3h472.1c139.6 0 253.1-113.5 253.1-253.1S761.1 315.3 621.5 315.3H234.7V230h386.8c186.6 0 338.4 151.8 338.4 338.4S808.1 906.8 621.5 906.8z" fill="#333333" p-id="7446"></path></svg>';



// WEBPACK FOOTER //
// ./src/display/platform/Network/TagTreeComponent/icon/cancel.ts